var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { InlineChildren, Stack, StackChildren, Text, } from '@doordash/design-language';
import { useHistory } from 'react-router-dom';
import { RecommendationTile } from './components';
import { HowToOrderResponseId, ProductOffering, QuizQuestionId, RecommendedProducts, WhereIsTeamResponseId, } from './QuizV2PageData';
import LocationPathHelper from '../../../utils/location_path_helper';
import { WorkBenefit } from '../../../types/GloblalTypes';
import { selfServeRoutes } from '../../../components/AppStructure/PublicRoutes';
import HowToPlaceOderModal from './components/HowToPlaceOrderModal';
import track from '../../../utils/track';
import { QuizEvents } from '../../../constants/events';
export var RecommendationView = function (_a) {
    var isMobile = _a.isMobile, title = _a.title, subtitle = _a.subtitle, questionResponses = _a.questionResponses;
    var history = useHistory();
    var _b = __read(React.useState(false), 2), isHowToPlaceOrderModalOpen = _b[0], setIsHowToPlaceOrderModalOpen = _b[1];
    var _c = __read(React.useState([]), 2), products = _c[0], setProducts = _c[1];
    React.useEffect(function () {
        var calculatedProducts = calculateProductsBasedOnResponses(questionResponses);
        track(QuizEvents.RECOMMENDATION_VIEW, {
            // first product is always recommended
            product: calculatedProducts[0].id,
        });
        setProducts(calculatedProducts);
    }, [questionResponses]);
    var calculateProductsBasedOnResponses = function (responses) {
        if (responses[QuizQuestionId.whereIsTeam] ===
            WhereIsTeamResponseId.inOfficeOrHybrid &&
            responses[QuizQuestionId.howToOrder] === HowToOrderResponseId.together) {
            // inOffice or Hybrid, and everyone orders together should return Group Order as recommended
            return [
                __assign(__assign({}, RecommendedProducts[ProductOffering.groupOrder]), { isRecommended: true }),
                RecommendedProducts[ProductOffering.catering],
                RecommendedProducts[ProductOffering.expensedMeals],
            ];
        }
        // otherwise, always return expensed meals as recommended
        return [
            __assign(__assign({}, RecommendedProducts[ProductOffering.expensedMeals]), { isRecommended: true }),
            RecommendedProducts[ProductOffering.catering],
            RecommendedProducts[ProductOffering.groupOrder],
        ];
    };
    var handleCtaClick = function (productId) {
        var recommendedProductId = products[0].id;
        if (productId === ProductOffering.catering) {
            track(QuizEvents.CATERING_ORDER_NOW_CLICK, {
                recommended: recommendedProductId,
            }, {}, function () {
                // simple redirect for catering
                // open new tab
                window.open(RecommendedProducts[productId].button.link, '_blank', 'noopener,noreferrer');
            });
            return;
        }
        if (productId === ProductOffering.groupOrder) {
            track(QuizEvents.GO_ORDER_NOW_CLICK, {
                recommended: recommendedProductId,
            }, {}, function () {
                // simple redirect for group order
                // open new tab
                window.open(RecommendedProducts[productId].button.link, '_blank', 'noopener,noreferrer');
            });
            return;
        }
        // expensed meals click
        track(QuizEvents.EM_ENROLL_NOW_CLICK, {
            recommended: recommendedProductId,
        });
        var search = LocationPathHelper.getWindowLocationSearch() || '';
        var urlQueryString = search;
        urlQueryString = urlQueryString + "&workBenefit=" + WorkBenefit.WORK_BENEFIT_EXPENSED_MEALS;
        history.push({
            pathname: selfServeRoutes.SIGN_UP_TEAM_ROUTE,
            search: urlQueryString,
        });
    };
    var handleOpenModalClick = function (productId) {
        if (productId === ProductOffering.groupOrder) {
            setIsHowToPlaceOrderModalOpen(true);
        }
    };
    var AlignProductsContainer = isMobile ? StackChildren : InlineChildren;
    return (React.createElement(React.Fragment, null,
        isHowToPlaceOrderModalOpen && (React.createElement(HowToPlaceOderModal, { onClose: function () { return setIsHowToPlaceOrderModalOpen(false); }, navigateToOrder: function () { return handleCtaClick(ProductOffering.groupOrder); } })),
        React.createElement(StackChildren, { size: Stack.Sizes.XxxLarge },
            React.createElement(StackChildren, { size: Stack.Sizes.XxxSmall },
                React.createElement(Text, { tag: "h1", styles: Text.Styles.PageTitle1, textAlign: Text.TextAlignments.Center }, title),
                React.createElement(Text, { styles: Text.Styles.Medium24, textAlign: Text.TextAlignments.Center, color: Text.Colors.TextSecondary }, subtitle)),
            React.createElement(AlignProductsContainer, null, products.map(function (product) { return (React.createElement(RecommendationTile, { key: product.id, product: product, onActionClick: handleCtaClick, onModalCtaClick: handleOpenModalClick })); })))));
};
export default RecommendationView;
